"use client"

import React from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { RECAPTCHA_SITE_KEY, isRecaptchaConfigured } from "@lib/constants"
import { WidgetErrorBoundary } from "@modules/common/components/error-boundary/widget-boundary"

type SafeRecaptchaProps = {
  onChange: (token: string | null) => void
  onExpired?: () => void
}

const SafeRecaptcha = React.forwardRef<ReCAPTCHA, SafeRecaptchaProps>(
  ({ onChange, onExpired }, ref) => {
    if (!isRecaptchaConfigured()) {
      return (
        <p className="text-xs text-gray-400">
          reCAPTCHA is not configured in this environment.
        </p>
      )
    }

    return (
      <WidgetErrorBoundary
        fallback={
          <p className="text-xs text-gray-400">
            Verification is temporarily unavailable. Please try again later.
          </p>
        }
      >
        <ReCAPTCHA
          ref={ref}
          sitekey={RECAPTCHA_SITE_KEY as string}
          onChange={onChange}
          onExpired={onExpired}
        />
      </WidgetErrorBoundary>
    )
  }
)

SafeRecaptcha.displayName = "SafeRecaptcha"

export default SafeRecaptcha
